var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-options"},[_c('ul',_vm._l((_vm.sizes),function(size,index){return _c('li',{class:{fontSizeActive: _vm.current === size},on:{"click":function($event){$event.stopPropagation();_vm.handleFontSizeClick(size, index)}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHtml(size, index))}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042e5a0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitlePicker.vue
// module id = null
// module chunks = 